import { Modal } from "@/utils/bootstrap";
import ModalAsPageHeader from "./ModalAsPageHeader";
import useIsRtl from "@/hooks/useIsRtl";

// export const pageDrawerAtom = atom(false);

interface Props {
  title: string;
  children: any;
  show: boolean;
  setShow: (show: boolean) => void;
  padding?: string;
  isPC?: boolean;
}
const PageDrawer: React.FC<Props> = ({
  title,
  show,
  setShow,
  children,
  padding,
  isPC = false,
}) => {
  const isRtl = useIsRtl();
  return (
    <Modal
      fullscreen
      backdrop={false}
      show={show}
      onHide={() => setShow(false)}
      className={`modal-as-drawer fade drawer ${isPC ? "pc" : ""} ${
        isRtl ? "right-align" : "left-align"
      }`}
    >
      {!isPC && (
        <ModalAsPageHeader title={title} onClose={() => setShow(false)} />
      )}
      <div style={{ padding: padding ?? "24px 16px 33px 16px" }}>
        {children}
      </div>
    </Modal>
  );
};

export default PageDrawer;
